import TrripLogo from '../../../../../assets/Trrip_logo/trrip_logo.png';

const NavbarBrand = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={TrripLogo}
        alt="Trrip"
        className="h-9 sm:h-12 md:h-14 lg:h-16 object-contain transition-all"
      />
    </div>
  );
};

export default NavbarBrand;
